<script>
  import Keyframe from "./Keyframe.svelte";
  import {modalStatus, currentMemory} from "../AppState/Stores";
  import {onMount} from "svelte";
  import {memory, CacheLoadState} from "../AppState/Cache";
  import PreviewStoryframe from "./PreviewStoryframe.svelte";

  export const MemoryListItemViewModel = {
    initial: 'initial',
    loading: 'loading',
    error: 'error',
    success: 'success',
  }

  export let memoryUUID;

  let fetchedMemory = null;
  onMount(() => {
    renderState(MemoryListItemViewModel.initial)

    memory(
      memoryUUID,
      (state) => {
        renderState(state)
      },
      (memory) => {
        fetchedMemory = memory
      })
  })

  function firstStoryframe() {
    if (fetchedMemory['storyFrames'][0] != null) {
      return fetchedMemory['storyFrames'][0]
    } else {
      return null
    }
  }

  let viewState = MemoryListItemViewModel.initial
  function renderState(state) {
    switch (state) {
      case CacheLoadState.loading:
        viewState = MemoryListItemViewModel.loading
        break
      case CacheLoadState.found:
        viewState = MemoryListItemViewModel.success
        break
      case CacheLoadState.failed:
         viewState = MemoryListItemViewModel.error
    }
  }

</script>

<memoryFrame on:click="{ () => {
  $modalStatus = 'on'
  $currentMemory = fetchedMemory
}}">
  {#if viewState === MemoryListItemViewModel.initial}
    <p>initial</p>
  {:else if viewState === MemoryListItemViewModel.loading}
    <p>loading</p>
  {:else if viewState === MemoryListItemViewModel.success}
      <div>
        <Keyframe keyframeData={fetchedMemory['keyframe']}/>
      </div>
    {#if firstStoryframe() != null}
      <PreviewStoryframe storyframeData={fetchedMemory['storyFrames'][0]}/>
    {/if}
  {:else if viewState === MemoryListItemViewModel.error}
    <p>something has gone wrong</p>
  {/if}

</memoryFrame>

<style>
  memoryFrame {
    width: calc(100vw - 1.5rem - 225px);
    max-width: 2000px;
    margin-bottom: 2.5rem;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
    padding-bottom: 5px;
    display: grid;
    grid-template-columns: minmax(550px, 75%) 1fr;
  }
  memoryFrame:hover {
    box-shadow: -2px 9px 10px -4px #272d35, 0px -9px 10px -4px #272d35;
    border-radius: 8px;
    background-color: rgb(248,248,248);
  }

  @media screen and (max-width: 1200px){
    memoryFrame{
      width: calc(100vw - 2rem - 225px);
      grid-template-columns: 1fr;
      grid-template-rows: 2fr 1fr;
    }
  }

</style>